<template>
  <div class="colorScreen_container bg">
    <div class="title-line">
      <div class="title-box"></div>
      <div class="key-value">
        <div class="time" id="time">{{ time }}</div>
        <div class="infoBox">
          <transition name="plus-icon">
            <el-row v-if="currentRow == 1">
              <el-col :span="12">
                <div class="led-key">
                  PM10<span class="led-unit">({{ getUnit("61") || "μm/m³" }})</span>
                </div>
                <div class="led-value number">{{ getValue("61") }}</div>
              </el-col>
              <el-col :span="12">
                <div class="led-key">
                  PM2.5<span class="led-unit">({{ getUnit("62") || "μm/m³" }})</span>
                </div>
                <div class="led-value number">{{ getValue("62") }}</div>
              </el-col>
            </el-row>
            <el-row v-else-if="currentRow == 2">
              <el-col :span="12">
                <div class="led-key">
                  温度<span class="led-unit">({{ getUnit("8") || "℃" }})</span>
                </div>
                <div class="led-value number">{{ getValue("8") }}</div>
              </el-col>
              <el-col :span="12">
                <div class="led-key">
                  湿度<span class="led-unit">({{ getUnit("22") || "%" }})</span>
                </div>
                <div class="led-value number">{{ getValue("22") }}</div>
              </el-col>
            </el-row>
            <el-row v-else-if="currentRow == 3">
              <el-col :span="12">
                <div class="led-key">
                  风速<span class="led-unit">({{ getUnit("65") || "m/s" }})</span>
                </div>
                <div class="led-value number">{{ getValue("65") }}</div>
              </el-col>
              <el-col :span="12">
                <div class="led-key">
                  风向<span class="led-unit">({{ getUnit("63") }})</span>
                </div>
                <div class="led-value number">{{ getValue("63") }}</div>
              </el-col>
            </el-row>
            <el-row v-else-if="currentRow == 4">
              <el-col :span="12">
                <div class="led-key">
                  降雨量<span class="led-unit">({{ getUnit("600") || "mm" }})</span>
                </div>
                <div class="led-value number">{{ getValue("600") }}</div>
              </el-col>
            </el-row>
          </transition>
          <template v-for="i in 4" :key="i">
            <div
              class="smallLine"
              :class="['line' + i, { current: i == currentRow }]"
            ></div>
          </template>
        </div>
      </div>
    </div>
    <div class="roadInfo">
      <div class="roadBox">
        <div class="road-name">
          道路名称：<span>{{ roadData.roadName ? roadData.roadName : "--" }}</span>
        </div>
        <div class="road-status">
          干湿状态：<span
            :class="[
              { dry: roadData.dryWetStatus == '干燥' },
              { wet: roadData.dryWetStatus == '湿润' },
              { normal: roadData.dryWetStatus == '中等' },
            ]"
            >{{ roadData.dryWetStatus ? roadData.dryWetStatus : "--" }}</span
          >
        </div>
      </div>
    </div>
    <div class="mapContainer">
      <myRoad
        v-for="(item, i) in roadArr"
        :key="i"
        :roadWidth="item.width"
        :roadTop="item.top"
        :roadLeft="item.left"
        :roadRotate="item.rotate"
        :roadHasCar="item.roadHasCar"
        :carInfo="item.carInfo"
        :currentRoad="roadData"
        :roadId="item.model_id"
        :carCurrentID="carCurrentID"
        :roadHeight="item.height"
      ></myRoad>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import {
  RealTimeCleanCarStartFunc,
  IsShowBoidsFunc,
  IsShowBuildingsFunc,
  IsShowTargetFunc,
  StopPathFunc,
  LoadPathFromJSFunc,
  RoadHeatLineFunc,
  ShowHeatLineFunc,
} from "@/assets/js/unity3D/index.js";

import { roadDataList } from "./roadList.js";
import unityFly from "./unityFly.js";
import myRoad from "./components/myRoad/myRoad.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { myRoad },
  props: {},
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      timer: null,
      timer2: null,
      timer3: null,
      timer4: null,
      time: "",
      dataList: [],
      isFlyAround: false,
      isCtrl: false,
      roadList: [],
      roadData: "",
      roadArr: [],
      carCurrentID: [],
      timer5: null,
      timer6: null,
      timerTitleShow: null,
      carListArr: [],
      sum: 0,
      tableDataJsonParse: [],
      roadStatus: [
        {
          status: "干燥",
          value: 100,
        },
        {
          status: "中等",
          value: 51,
        },
        {
          status: "湿润",
          value: 1,
        },
        // {
        //   status: null,
        //   value: 75,
        // },
      ],
      dataListShowTwo: [],
      currentRow: 1,
    };
  },
  //计算属性 类似于data概念
  computed: {
    getValue() {
      return (key) => {
        if (!this.dataList.length) return;
        let arr = this.dataList.filter((i) => i.categoryId == key);
        return arr[0] && arr[0].value;
      };
    },
    getUnit() {
      return (key) => {
        if (!this.dataList.length) return;
        let arr = this.dataList.filter((i) => i.categoryId == key);
        return arr[0] && arr[0].unit;
      };
    },
    flyRoadData() {
      return unityFly.filter((i) => {
        return i.include.includes(this.roadData.modelId);
      });
    },
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.roadArr = roadDataList;
    // console.log("roadDataList", this.roadArr);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //IsShowTargetFunc();
    try {
      this.getTime();
      this.getData();
      this.getData2();
    } catch (err) {
      console.log(err);
    }

    //IsShowBuildingsFunc();
    setTimeout(() => {
      IsShowBoidsFunc("true");
      IsShowTargetFunc("false");
    }, 500);
  },
  unmounted() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.timer2) {
      clearTimeout(this.timer2);
    }
    if (this.timer3) {
      clearInterval(this.timer3);
    }
    if (this.timer5) {
      clearInterval(this.timer5);
    }
    if (this.timer6) {
      clearInterval(this.timer6);
    }
    if (this.timer4) {
      clearTimeout(this.timer4);
    }
    if (this.timerTitleShow) {
      clearTimeout(this.timerTitleShow);
    }
  },
  //方法集合
  methods: {
    getData() {
      if (this.timer2) {
        clearTimeout(this.timer2);
      }
      this.getSignalRealValue();
      // this.getRoadData();
      this.getCaronRoad();
      this.timer2 = setTimeout(() => {
        this.getData();
      }, 1000 * 60 * 5);
    },
    getData2() {
      if (this.timer6) {
        clearTimeout(this.timer6);
      }
      this.getRoadData();
      this.timer6 = setTimeout(() => {
        this.getData2();
      }, 1000 * 60 * 20);
    },
    getTime() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        var time = new Date();
        var year = time.getFullYear(); //获取年份
        var month = time.getMonth() + 1; //获取月份
        var day = time.getDate(); //获取日期
        var hour = checkTime(time.getHours()); //获取时
        var minite = checkTime(time.getMinutes()); //获取分
        var second = checkTime(time.getSeconds()); //获取秒
        function checkTime(i) {
          if (i < 10) return "0" + i;
          return i;
        }
        var weeks = new Array(
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六"
        );
        var dayNum = time.getDay();
        var week = weeks[dayNum];
        this.time = `${year}年${month}月${day}日 ${week} ${hour}:${minite}:${second}`;
      }, 1000);
    },
    //获取空气参数
    async getSignalRealValue() {
      const url = `${CONFIG.requestNameRoad}/digit/getSignalRealValue`;
      const res = await this.$apiUtils.get(url, {
        ledNo: "rf_rgb_led_1",
        customerId: this.customerId,
      });
      this.dataList = res || [];
      this.getShowData();
    },
    getShowData() {
      if (this.timerTitleShow) {
        clearTimeout(this.timerTitleShow);
      }
      this.currentRow++;
      if (this.currentRow > 4) {
        this.currentRow = 1;
      }
      this.timerTitleShow = setTimeout(() => {
        this.getShowData();
      }, 1000 * 5);
    },
    //获取65条道路状态
    async getRoadData(cb) {
      if (this.timer3) {
        clearInterval(this.timer3);
      }
      const url = `${CONFIG.requestNameRoad}/digit/roadList`;
      const res = await this.$apiUtils.get(url, {
        customerId: this.customerId,
        roadId: null,
      });
      this.roadList = res || [];
      //生成所有路的json
      let AllJson = new Array(65);
      for (let i = 0; i < AllJson.length; i++) {
        AllJson[i] = { roadID: "42_" + (i + 1), value: 30 };
      }
      this.tableDataJsonParse = AllJson;
      let length = res.length;
      let i = 0;
      this.roadData = res[i];
      let that = this;

      this.timer3 = setInterval(() => {
        if (!this.isFlyAround) {
          $(".roadBox").animate({ opacity: "0" }, 1000, function () {
            if (i < length) {
              that.roadData = res[i];
              i++;
            } else {
              i = 0;
              that.roadData = res[i];
            }
            // $(".roadBox").css({ opacity: "0", left: "0" });
            $(".roadBox").animate({ opacity: "1" }, 1000, function () {
              cb && cb(); //数据更新的回调函数
              that.sum++;
              if (that.sum % 5 == 0) {
                if (that.flyRoadData?.length) {
                  that.getLoadPathFromJSFunc();
                } else {
                  that.sum--;
                }
              }
            });
          });
        }
      }, 10000);
    },
    //调取成都地图
    flyFunc() {
      console.log("this.roadData.modelId", this.roadData.modelId);
      StopPathFunc();
      let roadJSON = "";
      roadJSON = this.flyRoadData[0].json;
      let arr = this.roadStatus.filter((i) => i.status == this.roadData.dryWetStatus);
      let dryWetValue;
      if (arr.length) {
        dryWetValue = arr[0].value;
        let obj2 = JSON.parse(JSON.stringify(this.tableDataJsonParse));
        let HLJson = obj2.map((item) => {
          if (item.roadID == this.roadData.modelId) {
            item.value = dryWetValue;
            return item;
          } else {
            return item;
          }
        });
        RoadHeatLineFunc(JSON.stringify(HLJson));
        ShowHeatLineFunc();
      }
      console.log("lll", roadJSON);
      LoadPathFromJSFunc(roadJSON);
    },
    getLoadPathFromJSFunc() {
      let that = this;
      this.isFlyAround = true;
      $(".mapContainer").animate({ opacity: 0 }, 1000, function () {
        $(".colorScreen_container").removeClass("bg");
        that.flyFunc();
        that.timer4 = setTimeout(() => {
          that.isFlyAround = false;
          $(".colorScreen_container").addClass("bg");
          $(".mapContainer").animate({ opacity: 1 }, 1000, function () {});
        }, 15000);
      });
    },
    //获取有哪些车，并判断车在哪条路上
    async getCaronRoad() {
      const url = `${CONFIG.requestNameRoad}/digit/cleaner`;
      const res = await this.$apiUtils.get(url, {
        customerId: this.customerId,
        dtuNum: null,
      });
      this.carListArr = [];
      this.roadArr.forEach((i) => {
        i.carInfo = [];
      });
      res.forEach((i) => {
        this.carListArr.push(i.deviceNo);
        this.roadArr.forEach((i_) => {
          if (i.roadModelId === i_.model_id) {
            i_.roadHasCar = true;
            let car = {
              tduNum: i.dtuNum, //40910114055
              deviceName: i.deviceName, //洒水车_冀B2580S
              dtuName: i.dtuName, //冀B2580S
              typeName: i.typeName, //洒水车
              deviceNo: i.deviceNo,
              road_name: i_.road_name,
              todayDistance: i.todayDistance,
            };
            i_.carInfo.push(car);
          }
        });
      });
      this.getCarDataScoll();
    },
    //车辆信息弹窗轮播
    getCarDataScoll() {
      console.log("this.roadArr", this.roadArr);
      if (this.timer5) {
        clearInterval(this.timer5);
      }
      let i = 0;
      console.log("this.carListArr", this.carListArr);
      this.timer5 = setInterval(() => {
        this.carCurrentID = [];
        this.carCurrentID.push(this.carListArr[i]);
        this.carCurrentID.push(this.carListArr[i + 1]);
        i = i + 2;
        if (i >= this.carListArr.length) {
          i = 0;
        }
      }, 1000 * 5);
    },
  },
};
</script>
<style scoped lang="scss">
.bg {
  background: rgba(0, 0, 0, 0);
  @include bg-box(100%, 100%, "allmap.png");
}
.colorScreen_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 100000;
  .title-line {
    height: 440px;
    pointer-events: all;
    position: relative;
    .title-box {
      @include bg-box(100%, 420px, "title.png");
    }
    .key-value {
      position: absolute;
      width: 100%;
      top: 0;
      height: 100%;
      .time {
        margin-top: 145px;
        text-align: center;
        margin-bottom: 10px;
        height: 40px;
        font-size: 40px;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
      }
      .infoBox {
        height: 180px;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .smallLine {
          width: 200px;
          height: 6px;
          background: #ffffff;
          box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.19);
          border-radius: 16px;
          position: absolute;
          top: 190px;
          opacity: 0.09;
          &.line1 {
            left: 50px;
          }
          &.line2 {
            left: 300px;
          }
          &.line3 {
            left: 570px;
          }
          &.line4 {
            left: 820px;
          }
          &.current {
            animation-name: show;
            animation-duration: 1s;
            animation-timing-function: linear;
            animation-iteration-count: 1;
            animation-direction: normal;
            opacity: 1;
          }
          @keyframes show {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
        &::before {
          content: "";
          display: block;
          height: 100%;
          width: 1px;
          background: rgba(38, 76, 169, 0.53);
          position: absolute;
          left: 50%;
        }
        :deep(.el-row) {
          display: flex;
          flex-wrap: nowrap;
          position: absolute;
          width: 100%;
          top: 22px;
          .el-col {
            text-align: center;
          }
          .led-key {
            height: 50px;
            font-size: 40px;
            font-weight: 600;
            color: #233052;
            line-height: 50px;
            margin-bottom: 10px;
          }
          .led-value {
            height: 70px;
            font-size: 70px;
            font-weight: 400;
            color: #088755;
            line-height: 70px;
          }
          .led-unit {
            height: 33px;
            font-size: 28px;
            font-weight: 500;
            color: #18161a;
            line-height: 33px;
          }
        }
      }
    }
  }
  .mapContainer {
    position: absolute;
    top: 540px;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center;
    background-repeat: no-repeat;
    // background-image: url(./img/map.png);
    background-size: cover;
  }
  .roadInfo {
    width: 1029px;
    height: 119px;
    background: #fff;
    // border: 5px dashed #4681e5;
    pointer-events: all;
    position: absolute;
    bottom: 21px;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    z-index: 14;
    @keyframes move {
      from {
        left: 0;
      }
      to {
        left: -100%;
      }
    }
    .roadBox {
      display: flex;
      align-items: center;
      justify-content: space-around;
      position: absolute;
      width: 100%;
      top: -5px;
      overflow: hidden;
      height: 100%;
      &.move {
        animation: move 3s infinite;
      }
      .road-name {
        height: 50px;
        font-size: 36px;
        font-weight: 600;
        color: #131415;
        line-height: 50px;
        span {
          height: 50px;
          font-size: 36px;
          font-weight: 600;
          color: #004891;
          line-height: 50px;
        }
      }
      .road-status {
        height: 50px;
        font-size: 36px;
        font-weight: 600;
        color: #131415;
        line-height: 50px;
        span {
          height: 50px;
          font-size: 36px;
          font-weight: 600;
          color: #47ffdd;
          line-height: 50px;
          &.dry {
            color: #ff7373;
          }
          &.wet {
            color: #65c1fd;
          }
          &.normal {
            color: #47ffdd;
          }
        }
      }
    }
  }
}
.plus-icon-enter-active {
  transition: opacity 1s;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 1s;
}
.plus-icon-leave-to {
  opacity: 0;
}
</style>
